import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=4560c42b"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=4560c42b&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4560c42b')) {
      api.createRecord('4560c42b', component.options)
    } else {
      api.reload('4560c42b', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=4560c42b", function () {
      api.rerender('4560c42b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/footer/Footer.vue"
export default component.exports